module.exports = __webpack_public_path__ + "img/img6.ca8a20ae.png";